import React, { useState } from "react";
import moment from "moment";
// import SearchInput from "./SearchInput";
import ArrowDownIcon from "../../assets/icons/arrowDown";
import PrevIcon from "../../assets/icons/prev";
import NextIcon from "../../assets/icons/next";
import { IoMdEye } from "react-icons/io";
import Popup from "./Popup";
import { getDaysBetweenDates } from "../../Utils/leaveUtils";
import Textarea from "./Textarea";
import { Link } from "react-router";
import { getLeaveLabel } from "../../Utils/getUserUtitls";

const LeaveHistoryTable = ({ data }) => {
  const [selectedRow, setSelectedRow] = useState({});
  const [requestOpen, setRequestOpen] = useState(false);
  const [search, setSearch] = useState("");
  // const [monthFilter, setMonthFilter] = useState(moment().format("MMM"));
  // const [yearFilter, setYearFilter] = useState(moment().year());
  // const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const handleRequestOpen = (row) => {
    setSelectedRow(row);
    setRequestOpen(true);
  };

  const filteredData = data.filter((row) => {
    const name = row.first_name + " " + row.last_name;
    return name.toLowerCase().includes(search.toLowerCase());
  });

  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // const statusOptions = [
  //   { label: "All Status", value: "" },
  //   { label: "Present", value: "Present" },
  //   { label: "Absent", value: "Absent" },
  //   { label: "On Leave", value: "On Leave" },
  // ];

  return (
    <div className="w-full rounded-lg">
      {/* Filters */}
      <div className="flex justify-between items-start md:flex-row gap-3 mb-4"></div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table-auto w-full text-sm">
          <thead>
            <tr className="h-[52px] bg-white border border-l-0 border-r-0 border-[#a48572]/10 text-[#142b70]">
              <th className="px-4 text-left text-sm font-semibold">S No.</th>
              <th className="px-4 text-left text-sm font-semibold">Type</th>
              <th className="px-4 text-center text-sm font-semibold">Days</th>
              <th className="px-4 text-center text-sm font-semibold">From</th>
              <th className="px-4 text-center text-sm font-semibold">To</th>
              <th className="px-4 text-center text-sm font-semibold">
                Applied Date
              </th>
              <th className="px-4 text-center text-sm font-semibold">Status</th>
              <th className="px-4 text-center text-sm font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map((row, idx) => (
                <tr key={idx} className="relative hover:bg-[#f9f9f9]">
                  <td className="relative text-left py-3 px-4">
                    <p className="text-sm">
                      {(currentPage - 1) * rowsPerPage + idx + 1}
                    </p>
                  </td>
                  <td className="text-sm text-left py-3 pl-4">
                    {row.leave_type}
                  </td>
                  <td className="text-sm text-center py-3">
                    {getDaysBetweenDates(
                      moment(new Date(row.start_date)).format("YYYY-MM-DD"),
                      moment(new Date(row.end_date)).format("YYYY-MM-DD"),
                      row.sub_type
                    )}
                  </td>
                  <td className="text-sm text-center py-3">
                    {moment(row.start_date).format("DD MMM YYYY")}
                  </td>
                  <td className="text-sm text-center py-3">
                    {moment(row.end_date).format("DD MMM YYYY")}
                  </td>
                  <td className="text-sm text-center py-3">
                    {moment(row.applied_at).format("DD MMM YYYY")}
                  </td>
                  <td className="text-sm text-center py-3 font-medium">
                    <span
                      className={`px-2 py-1 mx-auto rounded ${
                        row.status === "Approved"
                          ? "text-[#00b734] bg-[#00932a]/10"
                          : "bg-[#de2b26]/10 text-[#142b70]"
                      }`}
                    >
                      {row.status}
                    </span>
                  </td>
                  <td className="text-sm text-center py-3 font-medium">
                    <IoMdEye
                      onClick={() => handleRequestOpen(row)}
                      className="text-[#c30f0a] text-lg cursor-pointer"
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-4">
        <div className="relative w-[190px] h-[30px] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="flex items-center h-[26px] px-[10px] rounded-lg bg-[#f9f9f9] cursor-pointer relative">
              <select
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                className="bg-transparent text-xs focus:outline-none cursor-pointer appearance-none pr-5"
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
              <ArrowDownIcon
                iconClass="absolute right-2 pointer-events-none"
                color="#142b70"
              />
            </div>
            <p className="text-sm text-[#142b70]/80">of {totalPages} pages</p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="disabled:opacity-40"
            >
              <PrevIcon color="#142b70" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="disabled:opacity-40"
            >
              <NextIcon color="#142b70" />
            </button>
          </div>
        </div>
      </div>
      <Popup
        isOpen={requestOpen}
        onClose={() => setRequestOpen(false)}
        title="Leave Request"
      >
        <div className="flex flex-col gap-3 mt-[30px] border shadow rounded-xl p-6">
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Leave Type</p>
            <span className="text-sm text-[#142b70]">
              {selectedRow?.leave_type}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Number of Days</p>
            <span className="text-sm text-[#142b70]">
              {getDaysBetweenDates(
                moment(new Date(selectedRow?.start_date)).format("YYYY-MM-DD"),
                moment(new Date(selectedRow?.end_date)).format("YYYY-MM-DD"),
                selectedRow?.sub_type
              )}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Leave Sub Type</p>
            <span className="text-sm text-[#142b70]">
              {getLeaveLabel(selectedRow?.sub_type)}
            </span>
          </div>
          {selectedRow?.medical_certificate && (
            <div className="flex justify-between gap-2 w-full pb-2 border-b">
              <p className="text-sm text-[#142b70]/70">Medical Certificate</p>
              <Link
                to={selectedRow?.medical_certificate}
                target="_blank"
                className="text-sm text-[#142b70] underline"
              >
                View
              </Link>
            </div>
          )}
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Start Date</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.start_date)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">End Date</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.end_date)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Applied At</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.applied_at)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            {/* <p className="text-sm text-[#142b70]/70">Reason</p> */}
            <Textarea
              value={selectedRow?.reason}
              disable={true}
              className="bg-[#F9F9F9] border-0 shadow"
            />
          </div>
        </div>
        {/* Footer */}
        <div className="flex justify-end gap-4">
          <button
            onClick={() => setRequestOpen(false)}
            className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
          >
            Close
          </button>
        </div>
      </Popup>
    </div>
  );
};

export default LeaveHistoryTable;
